import script from "./ButtonPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonPoints.vue?vue&type=script&setup=true&lang=js"

import "./ButtonPoints.vue?vue&type=style&index=0&id=353264b2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-353264b2"]])

export default __exports__